import { useContext, useEffect, useState } from "react";

import { Wrapper } from "./dashboard.styles";

import Screens from "../../components/screens/screens.component";
import SettingsModal from "../../components/modals/settings";
import AccountSelector from "../../components/AccountSelector";
import CustomSelect from "../../components/select/index";
import ThemeContext from "../../lib/theme-context";
import AuthContext from "../../lib/auth-context";
import { mongoDBRequest } from "../../services/api/dbRequest";
import { useNavigate } from "react-router-dom";
import { getJSON } from "../../utils/safeLocalStorage";
import useWindowDimensions from "../../utils/width";
import { clearAllCache, invalidateUserCache } from "../../utils/dataCache";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import MenuIcon from "@mui/icons-material/Menu";
import FormControlLabel from "@mui/material/FormControlLabel";

import Box from "@mui/material/Box";

import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import ListItemIcon from "@mui/material/ListItemIcon";

import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import TimelineIcon from "@mui/icons-material/Timeline";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import {
  buildMarketView,
  buildPills,
  formatDuration,
  formatLocalShort,
} from "../../components/clock/clock";
import throwMessage from "../../utils/throwMessage";
import { TIMEZONES, getCurrentServerTimeParts } from "../../utils/timezones";
import { accountService } from "../../services/api/accountService";

const DashBoard = () => {
  const [dataSettingsAnchorEl, setDataSettingsAnchorEl] = useState(null);
  const dataSettingsOpen = Boolean(dataSettingsAnchorEl);
  const [mobileMenuAnchorEl, setMobileMenuAnchorEl] = useState(null);
  const mobileMenuOpen = Boolean(mobileMenuAnchorEl);
  const [timezone, setTimezone] = useState(() => localStorage.getItem("economic-calendar-timezone") || "local");
  const [selectedAccount, setSelectedAccount] = useState(() => localStorage.getItem("selected-account-id") || "All");
  const [showGross, setShowGross] = useState(() => localStorage.getItem("show-gross") === "true");
  const [showGrossStatsBar, setShowGrossStatsBar] = useState(() => localStorage.getItem("show-gross-statsbar") === "true");
  const [slippageThreshold, setSlippageThreshold] = useState(() => {
    const user = getJSON("user", {});
    return user.slippageThreshold ?? 0.5;
  });
  const [reloadCountdown, setReloadCountdown] = useState(null);
  const handleDataSettingsClick = (event) => {
    setDataSettingsAnchorEl(event.currentTarget);
  };
  const handleDataSettingsClose = () => {
    setDataSettingsAnchorEl(null);
  };
  const handleMobileMenuClick = (event) => {
    setMobileMenuAnchorEl(event.currentTarget);
  };
  const handleMobileMenuClose = () => {
    setMobileMenuAnchorEl(null);
  };

    const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const theme = useContext(ThemeContext);
  const auth = useContext(AuthContext);
  const tab = auth.tab;
  const setTab = auth.setTab;
  const [isLoading, setIsloading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [accounts, setAccounts] = useState([]);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const loadAccounts = async () => {
      try {
        const fetched = await accountService.getAccounts();
        setAccounts(fetched);
      } catch (error) {
        console.error("Error loading accounts:", error);
      }
    };
    loadAccounts();
    window.addEventListener("accounts-updated", loadAccounts);
    return () => window.removeEventListener("accounts-updated", loadAccounts);
  }, []);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);


  const handleLogOut = async () => {
    auth.setLoading(true);
    const TC_TOKEN_AUTH = localStorage.getItem("TC_TOKEN_AUTH");
    
    try {
      await clearAllCache();
    } catch (error) {
      console.error("Error clearing cache:", error);
    }
    
    mongoDBRequest("sign-out", "POST", { TC_TOKEN_AUTH: TC_TOKEN_AUTH })
      .then((data) => {
        if (data === "goodbye") {
          localStorage.removeItem("TC_TOKEN_AUTH");
          localStorage.removeItem("user");
          localStorage.removeItem("backtest-mode");
          localStorage.removeItem("market_times_state");
          localStorage.removeItem("inprogress-mode");
          localStorage.removeItem("user");
          localStorage.removeItem("pre-trade-checklist");
          localStorage.removeItem("screen");
          localStorage.removeItem("view-mode");
          localStorage.removeItem("missed-trade");
          localStorage.removeItem("calendar-view-mode");
          localStorage.removeItem("backtest-active");
          localStorage.removeItem("rotater");
          localStorage.removeItem("trade-portal");
          localStorage.removeItem("TC-status");
          localStorage.removeItem("equityCurve");
          localStorage.removeItem("equity-mode");
          localStorage.removeItem("view-date");
          localStorage.removeItem("year");
          localStorage.removeItem("balanceIC");
          localStorage.removeItem("balancePC");
       
          localStorage.removeItem("rollingBalancesIC");
          localStorage.removeItem("rollingBalancesPC");
      
          localStorage.removeItem("rollingPercentsPC");
          localStorage.removeItem("rollingPercentsIC");
      
          localStorage.removeItem("stopwatch_state");
          localStorage.removeItem("results-tracker-enabled");
          localStorage.removeItem("selected-account-id");
          localStorage.removeItem("show-balance-statsbar");
          localStorage.removeItem("show-gross");
          localStorage.removeItem("show-gross-statsbar");
          localStorage.removeItem("showGross");
          localStorage.removeItem("showMetric");
          localStorage.removeItem("skipPreviousYears");
          localStorage.removeItem("sydney");
          localStorage.removeItem("tokyo");

          navigate("/");
          setTimeout(() => {
            window.location.reload(false);
            localStorage.removeItem("theme");
          }, 400);
        }
      })
      .catch((err) => {
        auth.throwMessage("error", JSON.stringify(err));
      });
  };
    const handleDarkMode = (event) => {
    if (theme[0] === "light") {
      theme[1]("dark");
      localStorage.setItem("theme", "dark");
    } else if (theme[0] === "dark") {
      theme[1]("light");
      localStorage.setItem("theme", "light");
    }
  };

  const handleScreenPick = (num) => {
    localStorage.removeItem("backtest-active");
    
    // If selecting the same screen, reload the page
    if (tab === num) {
      window.location.reload();
    } else {
      setTab(num);
      localStorage.setItem("screen", num);
    }
  };
    useEffect(() => {
    setIsloading(true);
    const screen = localStorage.getItem("screen");
    const tabValue = screen !== null ? Number(screen) : 0;
    setTab(tabValue);
    setIsloading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setTab]);

  
  const [openSettings, setOpenSettings] = useState(false);
  const [marketView, setMarketView] = useState(() => {
    return getJSON("market_times_state", null);
  });
  const [tick, setTick] = useState(0);
  const [showLocalTimes, setShowLocalTimes] = useState(true);
  const [showClosedCountdown, setShowClosedCountdown] = useState(false);
  const updateMarketView = () => {
    const view = buildMarketView();
    localStorage.setItem("market_times_state", JSON.stringify(view));
    localStorage.setItem("TC-status", view.status.market ? "Open" : "Closed");
    localStorage.setItem("sydney", view.status.sydney ? "true" : "false");
    localStorage.setItem("tokyo", view.status.tokyo ? "true" : "false");
    localStorage.setItem("london", view.status.london ? "true" : "false");
    localStorage.setItem("newYork", view.status.newYork ? "true" : "false");
    setMarketView(view);
  };

  useEffect(() => {
    // Initialize immediately on mount and keep the view in sync.
    updateMarketView();

    // Keep countdown numbers live.
    const secondInterval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);

    // Recompute session boundaries periodically to avoid stale state
    // and to handle background tab timer throttling.
    const refreshInterval = setInterval(() => {
      updateMarketView();
    }, 30000);

    // If the tab was hidden for a while, force a resync on visibility.
    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        updateMarketView();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      clearInterval(secondInterval);
      clearInterval(refreshInterval);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
  const handleOpenSettings = () => setOpenSettings(true);
  const compactClock = width < 900;

  // Add a small base padding to ensure the left edge of the first pill is always visible
  const dynamicPaddingLeft =
    width < 900
      ? `${Math.max(
          showLocalTimes ? 70 : 150,
          Math.min(200, Math.floor(width * 0.05))
        )}px`
      : "0px";
  const handleCloseSettings = () => setOpenSettings(false);

  const handleClockClick = () => {
    setShowLocalTimes((prev) => !prev);
  };













  return (
    <>
      <style>{`
        .clockScroller::-webkit-scrollbar { display: none; }
        #data-settings-menu::-webkit-scrollbar { display: none; }
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
      `}</style>
      <SettingsModal open={openSettings} onClose={handleCloseSettings} />
            <AppBar
        position="fixed"
        sx={{
          backgroundColor: theme[0] === "dark" ? "#25262b" : "#ffffff",
          borderBottom: theme[0] === "dark" ? "1px solid #2d2e33" : "1px solid #e5e7eb",
          boxShadow: "none",
          margin: "auto",
          zIndex: 1400,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {width < 899 ? (
              <IconButton
                size="small"
                edge="start"
                aria-label="menu"
                sx={{}}
                onClick={handleMobileMenuClick}
              >
                <Avatar
                  sx={{
                    height: "35px",
                    width: "35px",
                    color: theme[0] !== "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                    backgroundColor: theme[0] !== "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                  }}
                >
                  <MenuIcon
                    sx={{
                      height: "31px",
                      width: "31px",
                      color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                    }}
                  />
                </Avatar>
              </IconButton>
            ) : (
              <FormControl variant="standard" sx={{ minWidth: 120 }}>
                <Select
                  value={openSettings ? "settings" : tab}
                  onChange={(e) => handleScreenPick(e.target.value)}
                  renderValue={(selected) => {
                    if (selected === "settings") {
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <PersonOutlineIcon 
                            sx={{
                              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                              fontSize: "1.3rem"
                            }}
                          />
                          Account Management
                        </Box>
                      )
                    } else if (selected === 0) {
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <CalendarMonthIcon 
                            sx={{
                              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                              fontSize: "1.3rem"
                            }}
                          />
                          {auth.backtestingMode ? "BT Calendar" : "Calendar"}
                        </Box>
                      )
                    } else if (selected === 1) {
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <TimelineIcon 
                            sx={{
                              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                              fontSize: "1.3rem"
                            }}
                          />
                          {auth.backtestingMode ? "BT Tracker" : "Tracker"}
                        </Box>
                      )
                    } else if (selected === 2) {
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <QueryStatsIcon 
                            sx={{
                              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                              fontSize: "1.3rem"
                            }}
                          />
                          {auth.backtestingMode ? "BT Analyser" : "Analyser"}
                        </Box>
                      )
                    } else if (selected === 3) {
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <AttachMoneyIcon 
                            sx={{
                              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                              fontSize: "1.3rem"
                            }}
                          />
                          Income
                        </Box>
                      )
                    } else if (selected === 4) {
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <ArticleOutlinedIcon 
                            sx={{
                              color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                              fontSize: "1.3rem"
                            }}
                          />
                          Trading Plan
                        </Box>
                      )
                    }
                  }}
                  sx={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                    letterSpacing: "2px",
                    fontSize: width >= 899 ? "0.85em" : "0.68em",
                    fontWeight: 500,
                    "&:before": {
                      borderBottomColor: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                    },
                    "&:after": {
                      borderBottomColor: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                    },
                    "& .MuiSelect-icon": {
                      display: "none",
                    },
                    "& .MuiSelect-select": {
                      backgroundColor: "transparent",
                    },
                  }}
                  disableUnderline
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#ffffff",
                        border: theme[0] === "dark" ? "1px solid #2d2e33" : "1px solid #e5e7eb",
                        borderRadius: "12px",
                        boxShadow: theme[0] === "dark" 
                          ? "0 8px 32px rgba(0, 0, 0, 0.4)" 
                          : "0 8px 32px rgba(0, 0, 0, 0.12)",
                        mt: 1,
                      },
                    },
                  }}
                >
                  <MenuItem 
                    value={0}
                    onClick={() => {
                      if (tab === 0) {
                        console.log("Same screen selected, reloading...");
                        window.location.reload();
                      }
                    }}
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      fontWeight: 400,
                      padding: "12px 16px",
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                      },
                      "&.Mui-selected": {
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                        fontWeight: 500,
                      },
                    }}
                  >
                    <CalendarMonthIcon 
                      sx={{
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        fontSize: "1.2rem"
                      }}
                    />
                    {auth.backtestingMode ? "BT Calendar" : "Calendar"}
                  </MenuItem>
                  <MenuItem 
                    value={1}
                    onClick={() => {
                      if (tab === 1) {
                        console.log("Same screen selected, reloading...");
                        window.location.reload();
                      }
                    }}
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      fontWeight: 400,
                      padding: "12px 16px",
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                      },
                      "&.Mui-selected": {
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                        fontWeight: 500,
                      },
                    }}
                  >
                    <TimelineIcon 
                      sx={{
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        fontSize: "1.2rem"
                      }}
                    />
                    {auth.backtestingMode ? "BT Tracker" : "Tracker"}
                  </MenuItem>
                  <MenuItem 
                    value={2}
                    onClick={() => {
                      if (tab === 2) {
                        console.log("Same screen selected, reloading...");
                        window.location.reload();
                      }
                    }}
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      fontWeight: 400,
                      padding: "12px 16px",
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                      },
                      "&.Mui-selected": {
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                        fontWeight: 500,
                      },
                    }}
                  >
                    <QueryStatsIcon 
                      sx={{
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        fontSize: "1.2rem"
                      }}
                    />
                    {auth.backtestingMode ? "BT Analyser" : "Analyser"}
                  </MenuItem>
                  <MenuItem 
                    value={3}
                    onClick={() => {
                      if (tab === 3) {
                        console.log("Same screen selected, reloading...");
                        window.location.reload();
                      }
                    }}
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      fontWeight: 400,
                      padding: "12px 16px",
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                      },
                      "&.Mui-selected": {
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                        fontWeight: 500,
                      },
                    }}
                  >
                    <AttachMoneyIcon 
                      sx={{
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        fontSize: "1.2rem"
                      }}
                    />
                    Income
                  </MenuItem>
                  <MenuItem 
                    value={4}
                    onClick={() => {
                      if (tab === 4) {
                        console.log("Same screen selected, reloading...");
                        window.location.reload();
                      }
                    }}
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      fontWeight: 400,
                      padding: "12px 16px",
                      minHeight: "48px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                      },
                      "&.Mui-selected": {
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#ffffff" : "#000000",
                        fontWeight: 500,
                      },
                    }}
                  >
                    <ArticleOutlinedIcon 
                      sx={{
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        fontSize: "1.2rem"
                      }}
                    />
                    Trading Plan
                  </MenuItem>
                </Select>
              </FormControl>
            )}
          </div>
          {marketView ? (
            <div
              className="clockScroller"
              onClick={handleClockClick}
              style={{
                display: "flex",
                alignItems: "center",
                gap: compactClock ? "6px" : "12px",
                cursor: "pointer",
                flexShrink: 1,
                flexGrow: 1,
                overflowX: "auto",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                padding:
                  // Only add left padding on mobile *when market is open*
                  width < 900 && marketView?.status.market
                    ? `4px 0 0 ${dynamicPaddingLeft}`
                    : "4px 0",
                WebkitOverflowScrolling: "touch",
                justifyContent: "center",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {/* Market Closed pill */}
              {!marketView.status.market && (
                <Typography
                  variant="body2"
                  sx={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "#111",
                    px: 1,
                    py: 0.25,
                    borderRadius: "12px",
                    backgroundColor:
                      theme[0] === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "rgba(0,0,0,0.06)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowClosedCountdown((v) => !v);
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: showClosedCountdown
                        ? "#2E7D32"
                        : "#C62828",
                      marginRight: 6,
                    }}
                  />
                  {showClosedCountdown
                    ? `Opens ${formatDuration(
                        marketView?.countdowns?.cdNewYorkOpen ?? 0
                      )}`
                    : "Market Closed"}
                </Typography>
              )}
              {marketView.status.market &&
                buildPills(marketView, {
                  compactClock,
                  showLocalTimes,
                  tick,
                  theme,
                }).map((m) => (
                  <Typography
                    key={m.key}
                    variant="body2"
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#111",
                      px: 1,
                      py: 0.25,
                      borderRadius: "12px",
                      backgroundColor:
                        theme[0] === "dark"
                          ? "rgba(255,255,255,0.08)"
                          : "rgba(0,0,0,0.06)",
                      whiteSpace: "nowrap",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: compactClock ? "4px" : "6px",
                      fontSize: compactClock ? "0.75rem" : undefined,
                      fontVariantNumeric: "tabular-nums",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: m.dotColor,
                        marginRight: 6,
                      }}
                    />
                    {m.label}{" "}
                    {showLocalTimes
                      ? formatLocalShort(m.nextTime)
                      : formatDuration(m.msLeft)}
                  </Typography>
                ))}
              
            </div>
          ) : null}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Tooltip title="Data Settings">
                <IconButton
                  onClick={handleDataSettingsClick}
                  size="small"
                  aria-controls={dataSettingsOpen ? "data-settings-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={dataSettingsOpen ? "true" : undefined}
                  sx={{ marginRight: "-5px", padding: 0 }}
                >
                  <Avatar
                    sx={{
                      height: "35px",
                      width: "35px",
                      color:
                        theme[0] !== "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                      backgroundColor:
                        theme[0] !== "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                    }}
                  >
                    <SettingsIcon
                      sx={{
                        height: "31px",
                        width: "31px",
                        color:
                          theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                      }}
                    />
                  </Avatar>
                </IconButton>
              </Tooltip>
            </Box>
            
            {/* Data Settings Menu */}
            <Menu
              elevation={0}
              anchorEl={dataSettingsAnchorEl}
              id="data-settings-menu"
              open={dataSettingsOpen}
              onClose={handleDataSettingsClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              sx={{
                zIndex: 1500,
                "& .MuiPaper-root": {
                  borderRadius: "12px",
                  backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#ffffff",
                  boxShadow: theme[0] === "dark"
                    ? "0 8px 32px rgba(0, 0, 0, 0.4)"
                    : "0 8px 32px rgba(0, 0, 0, 0.12)",
                  border: theme[0] === "dark" ? "1px solid #2d2e33" : "1px solid #e5e7eb",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                },
              }}
              MenuListProps={{
                sx: {
                  backgroundColor: "transparent",
                  padding: "4px",
                  minWidth: "200px",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                },
              }}
            >
              <MenuItem
                disabled
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  opacity: 0.6,
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  padding: "4px 16px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                Data Settings
              </MenuItem>
              {!auth.backtestingMode && (
                <MenuItem
                  sx={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                    backgroundColor: "transparent",
                    fontSize: "1rem",
                    padding: "12px 16px",
                    minHeight: "48px",
                    "&:hover": {
                      backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                    },
                  }}
                >
                  <AccountSelector
                    value={selectedAccount}
                    onChange={(e) => {
                      setSelectedAccount(e.target.value);
                      localStorage.setItem("selected-account-id", e.target.value);
                      window.dispatchEvent(new CustomEvent("account-changed", { 
                        detail: { accountId: e.target.value } 
                      }));
                    }}
                    size="small"
                    fullWidth
                    showAggregateOptions={true}
                  />
                </MenuItem>
              )}
              <MenuItem
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  padding: "12px 16px",
                  minHeight: "48px",
                  justifyContent: "center",
                  gap: "24px",
                  "&:hover": {
                    backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                  <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", opacity: 0.6, letterSpacing: "0.5px" }}>All App</span>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <button
                      onClick={() => {
                        setShowGross(true);
                        localStorage.setItem("show-gross", "true");
                        window.dispatchEvent(new CustomEvent("gross-net-changed", { 
                          detail: { showGross: true } 
                        }));
                      }}
                      style={{
                        padding: "4px 8px",
                        backgroundColor: showGross
                          ? theme[0] === "dark" ? "rgba(34, 197, 94, 0.2)" : "rgba(34, 197, 94, 0.15)"
                          : "transparent",
                        color: showGross ? "#22c55e" : theme[0] === "dark" ? "#6b7280" : "#9ca3af",
                        border: showGross ? `2px solid #22c55e` : `2px solid ${theme[0] === "dark" ? "#374151" : "#e5e7eb"}`,
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: showGross ? "600" : "400",
                        fontSize: "11px",
                        whiteSpace: "nowrap",
                        opacity: showGross ? 1 : 0.5,
                      }}
                    >
                      G
                    </button>
                    <button
                      onClick={() => {
                        setShowGross(false);
                        localStorage.setItem("show-gross", "false");
                        window.dispatchEvent(new CustomEvent("gross-net-changed", { 
                          detail: { showGross: false } 
                        }));
                      }}
                      style={{
                        padding: "4px 8px",
                        backgroundColor: !showGross
                          ? theme[0] === "dark" ? "rgba(168, 85, 247, 0.2)" : "rgba(168, 85, 247, 0.15)"
                          : "transparent",
                        color: !showGross ? "#a855f7" : theme[0] === "dark" ? "#6b7280" : "#9ca3af",
                        border: !showGross ? `2px solid #a855f7` : `2px solid ${theme[0] === "dark" ? "#374151" : "#e5e7eb"}`,
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: !showGross ? "600" : "400",
                        fontSize: "11px",
                        whiteSpace: "nowrap",
                        opacity: !showGross ? 1 : 0.5,
                      }}
                    >
                      N
                    </button>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                  <span style={{ fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", opacity: 0.6, letterSpacing: "0.5px" }}>Stats Bar</span>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <button
                      onClick={() => {
                        setShowGrossStatsBar(true);
                        localStorage.setItem("show-gross-statsbar", "true");
                        window.dispatchEvent(new CustomEvent("gross-net-statsbar-changed", { 
                          detail: { showGross: true } 
                        }));
                      }}
                      style={{
                        padding: "4px 8px",
                        backgroundColor: showGrossStatsBar
                          ? theme[0] === "dark" ? "rgba(34, 197, 94, 0.2)" : "rgba(34, 197, 94, 0.15)"
                          : "transparent",
                        color: showGrossStatsBar ? "#22c55e" : theme[0] === "dark" ? "#6b7280" : "#9ca3af",
                        border: showGrossStatsBar ? `2px solid #22c55e` : `2px solid ${theme[0] === "dark" ? "#374151" : "#e5e7eb"}`,
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: showGrossStatsBar ? "600" : "400",
                        fontSize: "11px",
                        whiteSpace: "nowrap",
                        opacity: showGrossStatsBar ? 1 : 0.5,
                      }}
                    >
                      G
                    </button>
                    <button
                      onClick={() => {
                        setShowGrossStatsBar(false);
                        localStorage.setItem("show-gross-statsbar", "false");
                        window.dispatchEvent(new CustomEvent("gross-net-statsbar-changed", { 
                          detail: { showGross: false } 
                        }));
                      }}
                      style={{
                        padding: "4px 8px",
                        backgroundColor: !showGrossStatsBar
                          ? theme[0] === "dark" ? "rgba(168, 85, 247, 0.2)" : "rgba(168, 85, 247, 0.15)"
                          : "transparent",
                        color: !showGrossStatsBar ? "#a855f7" : theme[0] === "dark" ? "#6b7280" : "#9ca3af",
                        border: !showGrossStatsBar ? `2px solid #a855f7` : `2px solid ${theme[0] === "dark" ? "#374151" : "#e5e7eb"}`,
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: !showGrossStatsBar ? "600" : "400",
                        fontSize: "11px",
                        whiteSpace: "nowrap",
                        opacity: !showGrossStatsBar ? 1 : 0.5,
                      }}
                    >
                      N
                    </button>
                  </div>
                </div>
              </MenuItem>
              <MenuItem
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  padding: "12px 16px",
                  minHeight: "48px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  "&:hover": {
                    backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                }}
              >
                <span style={{ fontSize: "0.875rem", fontWeight: "500" }}>Slippage Threshold (pips)</span>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <button
                      onClick={async () => {
                        const newValue = Math.max(0, slippageThreshold - 0.5);
                        setSlippageThreshold(newValue);
                        
                        try {
                          const user = getJSON("user", {});
                          if (user._id) {
                            await mongoDBRequest("user-settings", "PUT", {
                              user_id: user._id,
                              slippageThreshold: newValue
                            });
                            
                            user.slippageThreshold = newValue;
                            localStorage.setItem("user", JSON.stringify(user));
                            await invalidateUserCache(user._id);
                            
                            // Recalculate all trades with new threshold
                            await mongoDBRequest("recalculate-all-trades", "POST", {});
                            
                            // Clear cache so next page load gets fresh data
                            await clearAllCache();
                            
                            // Start countdown for reload
                            setReloadCountdown(2);
                            const interval = setInterval(() => {
                              setReloadCountdown(prev => {
                                if (prev <= 0.1) {
                                  clearInterval(interval);
                                  window.location.reload();
                                  return null;
                                }
                                return prev - 0.1;
                              });
                            }, 100);
                          }
                        } catch (error) {
                          console.error("Failed to save slippage threshold:", error);
                          throwMessage("error", "Failed to save slippage threshold");
                          setSlippageThreshold(slippageThreshold + 0.5);
                          setReloadCountdown(null);
                        }
                      }}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: "16px",
                        minWidth: "32px",
                        touchAction: "manipulation",
                      }}
                      aria-label="Decrease slippage threshold"
                    >
                      −
                    </button>
                    <span style={{ 
                      fontSize: "1rem", 
                      fontWeight: "600",
                      minWidth: "40px",
                      textAlign: "center",
                      color: theme[0] === "dark" ? "#3b82f6" : "#2563eb"
                    }}>
                      {slippageThreshold.toFixed(1)}
                    </span>
                    <button
                      onClick={async () => {
                        const newValue = slippageThreshold + 0.5;
                        setSlippageThreshold(newValue);
                        
                        try {
                          const user = getJSON("user", {});
                          if (user._id) {
                            await mongoDBRequest("user-settings", "PUT", {
                              user_id: user._id,
                              slippageThreshold: newValue
                            });
                            
                            user.slippageThreshold = newValue;
                            localStorage.setItem("user", JSON.stringify(user));
                            await invalidateUserCache(user._id);
                            
                            // Recalculate all trades with new threshold
                            await mongoDBRequest("recalculate-all-trades", "POST", {});
                            
                            // Clear cache so next page load gets fresh data
                            await clearAllCache();
                            
                            // Start countdown for reload
                            setReloadCountdown(2);
                            const interval = setInterval(() => {
                              setReloadCountdown(prev => {
                                if (prev <= 0.1) {
                                  clearInterval(interval);
                                  window.location.reload();
                                  return null;
                                }
                                return prev - 0.1;
                              });
                            }, 100);
                          }
                        } catch (error) {
                          console.error("Failed to save slippage threshold:", error);
                          throwMessage("error", "Failed to save slippage threshold");
                          setSlippageThreshold(slippageThreshold - 0.5);
                          setReloadCountdown(null);
                        }
                      }}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                        color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: "16px",
                        minWidth: "32px",
                        touchAction: "manipulation",
                      }}
                      aria-label="Increase slippage threshold"
                    >
                      +
                    </button>
                  </div>
                {reloadCountdown !== null && (
                  <span style={{ 
                    fontSize: "0.75rem", 
                    opacity: 0.7,
                    marginTop: "8px"
                  }}>
                    Reloading in {reloadCountdown.toFixed(1)}s...
                  </span>
                )}
              </MenuItem>
              <MenuItem
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  padding: "12px 16px",
                  minHeight: "48px",
                  "&:hover": {
                    backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                }}
              >
                <FormControlLabel
                  sx={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                    marginLeft: "5px",
                    fontSize: "1rem",
                  }}
                  control={
                    <Switch
                      inputProps={{ "aria-label": "Historical Trades" }}
                    />
                  }
                  label="Historical Trades"
                  name="Historical Trades"
                  checked={localStorage.getItem("skipPreviousYears") !== "true"}
                  onChange={async (e) => {
                    const newValue = !e.target.checked;

                    // Save to localStorage immediately for UI responsiveness
                    localStorage.setItem("skipPreviousYears", newValue);

                    // Save to database
                    try {
                      const user = getJSON("user", {});
                      if (user._id) {
                        const { mongoDBRequest } = require("../../services/api/dbRequest");
                        await mongoDBRequest("user-settings", "PUT", {
                          user_id: user._id,
                          skipPreviousYears: newValue
                        });

                        // Update user object in localStorage
                        user.skipPreviousYears = newValue;
                        localStorage.setItem("user", JSON.stringify(user));

                        // Invalidate cache so next page load gets updated user data
                        await invalidateUserCache(user._id);
                      }
                    } catch (error) {
                      console.error("Failed to save setting:", error);
                      throwMessage("error", "Failed to save setting");
                      // Revert localStorage change on failure
                      localStorage.setItem("skipPreviousYears", !newValue);
                    }

                    // Trigger a refresh of the stats bar by dispatching a custom event
                    window.dispatchEvent(new CustomEvent("settings-changed"));
                  }}
                />
              </MenuItem>
              <MenuItem
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                  backgroundColor: "transparent",
                  minHeight: "48px",
                  "&:hover": {
                    backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                }}
              >
                <FormControlLabel
                  sx={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                    marginLeft: "5px",
                    fontSize: "1rem",
                  }}
                  control={
                    <Switch
                      inputProps={{ "aria-label": "Backtesting Mode" }}
                    />
                  }
                  label="Backtesting Mode"
                  name="Backtesting Mode"
                  checked={auth.backtestingMode}
                  onChange={(e) => {
                    const newValue = e.target.checked;
                    if (auth.handleBacktestingMode) {
                      auth.handleBacktestingMode(newValue);
                    }
                    localStorage.setItem("backtest-mode", newValue);
                    localStorage.removeItem("backtest-active");
                    // Set account selector to All Personal Accounts when entering backtesting mode
                    if (newValue) {
                      localStorage.setItem("selected-account-id", "All Personal");
                      localStorage.setItem("equity-mode", "Personal Capital");
                      // Dispatch event to notify AccountSelector components
                      window.dispatchEvent(new CustomEvent("account-changed", { 
                        detail: { accountId: "All Personal" } 
                      }));
                    }
                  }}
                />
              </MenuItem>
              <Divider
                sx={{
                  backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                  width: "90%",
                  marginLeft: "7px",
                }}
              />
              <MenuItem
                disabled
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  opacity: 0.6,
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  padding: "4px 16px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                Account Management
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleDataSettingsClose();
                  handleOpenSettings();
                }}
                sx={{
                  marginLeft: "8px",
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  padding: "12px 16px",
                  minHeight: "48px",
                  "&:hover": {
                    backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                }}
              >
                <ListItemIcon>
                  <PersonOutlineIcon
                    fontSize="small"
                    sx={{
                      color:
                        theme[0] === "dark"
                          ? "#FCFCFF"
                          : "rgba(40, 42, 46)",
                    }}
                  />
                </ListItemIcon>
                Accounts
              </MenuItem>
              <Divider
                sx={{
                  backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                  width: "90%",
                  marginLeft: "7px",
                }}
              />
              <MenuItem
                disabled
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  opacity: 0.6,
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  padding: "4px 16px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                Timezone
              </MenuItem>
              <MenuItem
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  padding: "12px 16px",
                  minHeight: "48px",
                  "&:hover": {
                    backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                }}
              >
                <ListItemIcon>
                  <AccessTimeIcon
                    fontSize="small"
                    sx={{
                      color:
                        theme[0] === "dark"
                          ? "#FCFCFF"
                          : "rgba(40, 42, 46)",
                    }}
                  />
                </ListItemIcon>
                <CustomSelect
                  size="small"
                  value={timezone}
                  onChange={(e) => {
                    setTimezone(e.target.value);
                    localStorage.setItem("economic-calendar-timezone", e.target.value);
                  }}
                  menuItemArray={JSON.stringify(TIMEZONES)}
                  sx={{ minWidth: 200, ml: -1 }}
                />
              </MenuItem>
              <Divider
                sx={{
                  backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                  width: "90%",
                  marginLeft: "7px",
                }}
              />
              <MenuItem
                disabled
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  backgroundColor: "transparent",
                  opacity: 0.6,
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  padding: "4px 16px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                Account Server Time
              </MenuItem>
              {accounts.map((account) => (
                <MenuItem
                  key={`server-time-${account.id}`}
                  disabled
                  sx={{
                    color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                    backgroundColor: "transparent",
                    fontSize: "0.875rem",
                    padding: "8px 16px",
                    minHeight: "36px",
                    justifyContent: "space-between",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Typography component="span" sx={{ color: "inherit" }}>
                    {account.name}
                  </Typography>
                  <Box
                    component="span"
                    sx={{
                      color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {(() => {
                      const parts = getCurrentServerTimeParts(account, now);
                      return parts ? (
                        <>
                          <span style={{ fontWeight: 700, color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e" }}>
                            {parts.time}
                          </span>
                          <span>
                            {parts.label} ({parts.season})
                          </span>
                        </>
                      ) : (
                        "Not set"
                      );
                    })()}
                  </Box>
                </MenuItem>
              ))}

              {/* Profile menu items - shown on both mobile and desktop */}
              {[
                  <Divider
                    key="mobile-divider-1"
                    sx={{
                      backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                      width: "90%",
                      marginLeft: "7px",
                    }}
                  />,
                  <MenuItem
                    key="mobile-internet-label"
                    disabled
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      opacity: 0.6,
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      padding: "4px 16px",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    Internet
                  </MenuItem>,
                  <MenuItem
                    key="mobile-internet-status"
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      padding: "12px 16px",
                      minHeight: "48px",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: isOnline ? "#4CAF50" : "#f44336",
                  }}
                />
                {isOnline ? "Connected" : "Disconnected"}
              </MenuItem>,
              <Divider
                key="mobile-divider-2"
                sx={{
                  backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                  width: "90%",
                  marginLeft: "7px",
                }}
              />,
                  <MenuItem
                    key="mobile-theme-label"
                    disabled
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      opacity: 0.6,
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      padding: "4px 16px",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    Theme
                  </MenuItem>,
                  <MenuItem
                    key="mobile-theme-switch"
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                      },
                    }}
                  >
                    <FormControlLabel
                      sx={{
                        color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
                        marginLeft: "5px",
                      }}
                      control={
                        <Switch
                          inputProps={{ "aria-label": "Light Or Dark Mode" }}
                        />
                      }
                      label={theme[0] === "dark" ? "Dark" : "Light"}
                      name="light or dark mode"
                      checked={theme[0] === "dark" ? true : false}
                      onChange={handleDarkMode}
                    />
                  </MenuItem>,
                  <Divider
                    key="mobile-divider-3"
                    sx={{
                      backgroundColor: theme[0] === "dark" ? "#2d2e33" : "#e5e7eb",
                      width: "90%",
                      marginLeft: "7px",
                    }}
                  />,
                  <MenuItem
                    key="mobile-logout"
                    onClick={handleLogOut}
                    sx={{
                      color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                      backgroundColor: "transparent",
                      fontSize: "1rem",
                      padding: "12px 16px",
                      minHeight: "48px",
                      justifyContent: "center",
                      "&:hover": {
                        backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                      },
                    }}
                  >
                    <ListItemIcon>
                      <Logout
                        fontSize="small"
                        sx={{
                          color:
                            theme[0] === "dark"
                              ? "#FCFCFF"
                              : "rgba(40, 42, 46)",
                        }}
                      />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
              ]}
            </Menu>
          
          {/* Mobile Navigation Menu */}
          <Menu
            elevation={0}
            anchorEl={mobileMenuAnchorEl}
            id="mobile-menu"
            open={mobileMenuOpen}
            onClose={handleMobileMenuClose}
            transformOrigin={{ horizontal: "left", vertical: "top" }}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            sx={{
              zIndex: 1500,
            }}
            MenuListProps={{
              sx: {
                backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#ffffff",
                border: theme[0] === "dark" ? "1px solid #2d2e33" : "1px solid #e5e7eb",
                borderRadius: "0",
                boxShadow: theme[0] === "dark" 
                  ? "0 8px 32px rgba(0, 0, 0, 0.4)"
                  : "0 8px 32px rgba(0, 0, 0, 0.12)",
                padding: "4px",
                minWidth: "200px",
              },
            }}
            PaperProps={{
              sx: {
                backgroundColor: theme[0] === "dark" ? "#1a1b1e" : "#ffffff",
                borderRadius: "0",
                boxShadow: theme[0] === "dark" 
                  ? "0 8px 32px rgba(0, 0, 0, 0.4)"
                  : "0 8px 32px rgba(0, 0, 0, 0.12)",
                border: theme[0] === "dark" ? "1px solid #2d2e33" : "1px solid #e5e7eb",
                overflow: "hidden",
              }
            }}
          >
            <MenuItem 
              onClick={() => {
                handleMobileMenuClose();
                handleScreenPick(0);
              }}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                backgroundColor: "transparent",
                fontSize: "1rem",
                fontWeight: 400,
                padding: "12px 16px",
                minHeight: "48px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                "&:hover": {
                  backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  color: theme[0] === "dark" ? "#ffffff" : "#000000",
                },
              }}
            >
              <CalendarMonthIcon 
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  fontSize: "1.2rem"
                }}
              />
              Calendar
            </MenuItem>
            <MenuItem 
              onClick={() => {
                handleMobileMenuClose();
                handleScreenPick(1);
              }}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                backgroundColor: "transparent",
                fontSize: "1rem",
                fontWeight: 400,
                padding: "12px 16px",
                minHeight: "48px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                "&:hover": {
                  backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  color: theme[0] === "dark" ? "#ffffff" : "#000000",
                },
              }}
            >
              <TimelineIcon 
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  fontSize: "1.2rem"
                }}
              />
              Tracker
            </MenuItem>
            <MenuItem 
              onClick={() => {
                handleMobileMenuClose();
                handleScreenPick(2);
              }}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                backgroundColor: "transparent",
                fontSize: "1rem",
                fontWeight: 400,
                padding: "12px 16px",
                minHeight: "48px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                "&:hover": {
                  backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  color: theme[0] === "dark" ? "#ffffff" : "#000000",
                },
              }}
            >
              <QueryStatsIcon 
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  fontSize: "1.2rem"
                }}
              />
              Analyser
            </MenuItem>
            <MenuItem 
              onClick={() => {
                handleMobileMenuClose();
                handleScreenPick(3);
              }}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                backgroundColor: "transparent",
                fontSize: "1rem",
                fontWeight: 400,
                padding: "12px 16px",
                minHeight: "48px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                "&:hover": {
                  backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  color: theme[0] === "dark" ? "#ffffff" : "#000000",
                },
              }}
            >
              <AttachMoneyIcon 
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  fontSize: "1.2rem"
                }}
              />
              Income
            </MenuItem>
            <MenuItem 
              onClick={() => {
                handleMobileMenuClose();
                handleScreenPick(4);
              }}
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                backgroundColor: "transparent",
                fontSize: "1rem",
                fontWeight: 400,
                padding: "12px 16px",
                minHeight: "48px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
                "&:hover": {
                  backgroundColor: theme[0] === "dark" ? "#25262b" : "#f9fafb",
                  color: theme[0] === "dark" ? "#ffffff" : "#000000",
                },
              }}
            >
              <ArticleOutlinedIcon 
                sx={{
                  color: theme[0] === "dark" ? "#FCFCFF" : "#1a1b1e",
                  fontSize: "1.2rem"
                }}
              />
              Trading Plan
            </MenuItem>
          </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Wrapper maxWidth="auto">{!isLoading && <Screens />}</Wrapper>
    </>
  );
};

export default DashBoard;
